import { Box, Button, Typography } from '@mui/material';
import { BoxFC, BoxFR } from 'components/BoxCustom';
import DataGridCellExpand from 'components/DataGridCellExpand/DataGridCellExpand';
import React, { useCallback, useState, useContext, useEffect } from 'react';
import { columns } from './columns';
import { GlobalStateContext } from 'contexts/GlobalStateContext';
import SearchButton from 'components/buttons/SearchButton';
import ClearButton from 'components/buttons/ClearButton';
import { initFilterData, clearFilterData } from './initData';
import { branchApiNm } from 'branch/constant/branchApiNm';
import DateTimeSelect from 'components/DateTimeSelect';
import dayjs from 'dayjs';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import DailyJobDialogV3 from 'pages/Menu1/DailyJob/DailyJobDialogV3';
import { cyan, green, lime, orange, red } from '@mui/material/colors';
import { sortObjByDteTm } from 'utils';
import { PrintRounded } from '@mui/icons-material';
import { printDailyDriverStatus } from './printDailyDriverStatus';

let selectedJobOrdId = 0
const boxColor = {
  minWidth: 120, textAlign: "center", p: 0.5,
}
// const calculateCellClassName = ({ value }) => {
//   if (!value) return ""
//   if ([1,2,3].includes( value.ShpmTypId)) { //import, export, shuttle
//     return "near"
//   } else if ([4,6].includes(value.ShpmTypId)) {//Vssel, border
//     return "far"
//   } else if (value.ShpmTypId === 4) {
//     return "land"
//   } else if (value.JobOrdId) {
//     return "other"
//   }
//   if (value.TukAttnStsId > 100) {
//     return "absent"
//   } else if (value.DrvAttnStsId > 1) {
//     return "absent"
//   }
//   return ""
// }

const DailyDriverStatus = () => {
  const { ax, msData } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])
  const [filterData, setFilterData] = useState({ ...initFilterData })
  const [dataColumn, setDataColumn] = useState([...columns])
  const [dialogOpen, setDialogOpen] = useState(false)

  const apiRef = useGridApiRef();


  const getData = useCallback((filter) => {


    ax.post(branchApiNm.getDailyDriverStatus, filter).then(value => {
      if (value.data) {
        const result = []
        let no = 0
        for (const drv of value.data) {
          // if(['74-0983', '74-7193'].includes(drv.LicNm)) continue
          no++
          const row = {
            id: drv.DrvId,
            No: no,
            DrvNm: drv.DrvNm,
            LicNm: drv.LicNm,
          }

          sortObjByDteTm(drv.DrvAttns, "DrvAttnDte")
          sortObjByDteTm(drv.TukAttns, "TukAttnDte")
          // console.log("drv.DrvAttns", drv.DrvAttns)
          
          let lastAptTm = dayjs("1970-01-01")

          const calculateAbsent = (mode) => {
            for (let i = 0; i < drv[`${mode}Attns`].length; i++) {
              const da = drv[`${mode}Attns`][i]
              if (da[`${mode}AttnStsId`] < 100) continue

              let curCell = row[`d${dayjs(da[`${mode}AttnDte`]).format("MMDD")}`] || {}
              if (curCell?.JobOrdId) continue

              const curDte = dayjs(da[`${mode}AttnDte`])
              let hasDa = true
              let colSpan = 1
              let runDte = 0
              if (drv.LicNm === "74-6985") {
                console.log("da", da)
              }
              while (hasDa) {
                runDte++
                const nextIndex = i + 1
                if (nextIndex >= drv[`${mode}Attns`].length) break
                const nextData = drv[`${mode}Attns`][nextIndex]
                if (curDte.add(runDte, "day").format("YYYY-MM-DD") !== nextData[`${mode}AttnDte`]) break
                if (nextData && nextData[`${mode}AttnStsId`] === da[`${mode}AttnStsId`]) {
                  colSpan++
                  i++
                } else {
                  hasDa = false
                }
              }
              // curCell = {
              //   ...curCell,
              //   ...da,
              //   [`${mode}Dscp`]: da.Dscp,
              //   addColSpan: colSpan
              // }
              row[`d${dayjs(da[`${mode}AttnDte`]).format("MMDD")}`] = {
                jobOrder: null,
                text: da[`${mode}AttnStsId`] > 100 ? `${da[`${mode}AttnStsNm`]}${da.Dscp ? `(${da.Dscp})` : ""}` : "",
                colSpan: colSpan,
                className: "absent"
              }
              if(dayjs(da[`${mode}AttnDte`]).add(colSpan -1, 'day') > lastAptTm){
                lastAptTm = dayjs(da[`${mode}AttnDte`]).add(colSpan-1, 'day')
              }
              
            if(drv.LicNm === '73-2565'){
              console.log("licnm 73-2565 lastAptTm", lastAptTm.format("YYYY-MM-DD HH:mm"))  
            }
            }
          }
          calculateAbsent("Drv")
          calculateAbsent("Tuk")

          sortObjByDteTm(drv.JobOrders, "AptTm")
          for (let i = 0; i < drv.JobOrders.length; i++) {
            const jo = drv.JobOrders[i]
            const allTms = []


            
            if(jo.TakeArvTm && jo.DrvId1 === drv.DrvId && !jo.DrvId3 && !jo.DrvId5){
              allTms.push(+dayjs(jo.TakeArvTm))
            } else {
              if (jo.TakeArvTm || jo.TakeLevTm
                || jo.ArvTm || jo.LevTm
                || jo.RtnLevTm || jo.RtnArvTm) {
                jo.TakeArvTm && allTms.push(+dayjs(jo.TakeArvTm))
                jo.TakeLevTm && allTms.push(+dayjs(jo.TakeLevTm))
                jo.ArvTm && allTms.push(+dayjs(jo.ArvTm))
                jo.LevTm && allTms.push(+dayjs(jo.LevTm))
                jo.RtnLevTm && allTms.push(+dayjs(jo.RtnLevTm))
                jo.RtnArvTm && allTms.push(+dayjs(jo.RtnArvTm))
                i === drv.JobOrders.length - 1 && !jo.RtnLevTm && drv.IsSub === 0 && allTms.push(+dayjs())
              } else {
                allTms.push(+dayjs(jo.AptTm))
              }
            }
            

            let minTm = dayjs(Math.min(...allTms)).startOf('day')
            let maxTm = dayjs(Math.max(...allTms)).startOf('day')

            if(drv.LicNm === '73-2565'){
              console.log("licnm 73-2565 min max", jo.JobOrdId, minTm.format("YYYY-MM-DD HH:mm"), maxTm.format("YYYY-MM-DD HH:mm"))
            }
            let className = ""
            if (jo.JobOrdId) {
              if (jo.ShpmTypId === 5) {
                className = "land"
              } else if ([4, 6].includes(jo.ShpmTypId) || +(jo.UntPr || 0) > 15000) {//Vssel, border
                className = "far"
              } else if ([1, 2, 3].includes(jo.ShpmTypId)) { //import, export, shuttle
                className = "near"
              } else {
                className = "other"
              }
            }
            if(drv.LicNm === '73-2565'){
              console.log("licnm 73-2565 lastAptTm", lastAptTm.format("YYYY-MM-DD HH:mm"))  
            }
            let curDte = minTm
            if(minTm <= lastAptTm && maxTm > lastAptTm ){
              curDte = lastAptTm.add(1, 'day')
            }
            jo.colSpan = maxTm.startOf('day').diff(curDte.startOf('day'), 'day') + 1
            row[`d${curDte.format("MMDD")}`] = {
              jobOrder: jo,
              JobOrdId: jo.JobOrdId,
              text: jo.JobNm,
              colSpan: drv.IsSub === 1 ? 2 : jo.colSpan,
              className: className
            }
            lastAptTm = maxTm

            // row[`d${dayjs(jo.TakeArvTm || jo.AptTm).format("MMDD")}`] = jo
          }
          result.push(row)
        }
        console.log("result", result)

        const newColumns = columns.map(col => ({ ...col }))
        let runDte = dayjs(filter.AptTmSt).startOf('day')
        let endDte = dayjs(filter.AptTmEn).startOf('day')
        while (runDte <= endDte) {
          newColumns.push({
            field: `d${runDte.format("MMDD")}`,
            headerName: runDte.format("DD/MM"),
            width: 120,
            printWidth: 1.06,
            valueFormatter: ({ value }) => value?.text || "",
            colSpan: ({ value }) => value?.colSpan || 1,
            cellClassName: ({ value }) => value?.className || ""
          })
          runDte = runDte.add(1, 'day')
        }
        setDataColumn(newColumns)
        setDataTable(result)
      }
    })
  }, [ax])

  const handleCellClick = useCallback(({ value }) => {
    if (value && value.JobOrdId) {
      console.log(value)
      selectedJobOrdId = value.JobOrdId
      setDialogOpen(true)
    }
  }, [])

  const handlePrint = useCallback(() => {
    console.log(dataTable)
    printDailyDriverStatus({ msData, dataTable, dataColumn, dteSt: filterData.AptTmSt, dteEn: filterData.AptTmEn })
  }, [dataTable, filterData, msData, dataColumn])

  useEffect(() => {
    getData({ ...initFilterData })
  }, [getData])

  useEffect(() => {
    //monthColumns.length > 20 means already loaded
    if (dataColumn.length > 3 && apiRef.current) {
      setTimeout(() => {
        apiRef.current.scrollToIndexes({ rowIndex: 0, colIndex: dataColumn.length - 1 })
      }, 500);
    }
  }, [dataColumn, apiRef])

  console.log("dataTable", dataTable)
  return (
    <BoxFC height='100%'>
      <BoxFR>
        <Button variant="contained" onClick={handlePrint}><PrintRounded sx={{ mr: 1 }} /> พิมพ์</Button>
        <Box flex={1} />
        <Typography {...boxColor} bgcolor={green[400]}>เรือ+ข้ามแดน+งานไกล</Typography>
        <Typography {...boxColor} bgcolor={cyan[400]}>Import+Export+Shuttle</Typography>
        <Typography {...boxColor} bgcolor={orange[400]}>ตู้บก</Typography>
        <Typography {...boxColor} bgcolor={lime[400]}>อื่นๆ</Typography>
        <Box flex={1} />
        <DateTimeSelect
          sx={{ width: 180 }}
          label=""
          start={filterData.AptTmSt}
          end={filterData.AptTmEn}
          setSelectDate={(st, en) => { setFilterData(o => ({ ...o, AptTmSt: st, AptTmEn: en })) }}
          getData={() => { getData(filterData) }}
        />
        <SearchButton onClick={(() => getData(filterData))} />
        <ClearButton onClick={(() => setFilterData({ ...clearFilterData }))} />
      </BoxFR>
      <Box height='100%' sx={{
        "& .far": { bgcolor: green[400] },
        "& .near": { bgcolor: cyan[400] },
        "& .land": { bgcolor: orange[400] },
        "& .other": { bgcolor: lime[400] },
        "& .absent": { bgcolor: red[400] },
      }}>
        <DataGridCellExpand
          apiRef={apiRef}
          hideFooter
          rows={dataTable}
          columns={dataColumn}
          initialState={{ pinnedColumns: { left: ['No', 'DrvNm', 'LicNm'] } }}
          // onRowDoubleClick={handleRowDoubleClick}
          onCellClick={handleCellClick}
        />
      </Box>
      <DailyJobDialogV3
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        selectedId={selectedJobOrdId}
        onFinish={() => getData(filterData)} />
    </BoxFC>
  );
}

export default DailyDriverStatus